<template>
  <div>
    <h3>Lesson</h3>

    <vs-breadcrumb class="mt-2">
      <li><router-link to="/surveys">Surveys</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="parentOnlineTrainingLink">Online Training - {{ $translate(surveyTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li><router-link :to="parentModuleLink">{{ $translate(moduleTitle) }}</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li aria-current="page" class="active">{{ $translate(lessonTitle) }}</li>
    </vs-breadcrumb>

    <vs-tabs
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none mt-8"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <lesson-general v-if="item" :lesson="item" />
        </div>
      </vs-tab>

      <!-- QUESTIONS -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Questions' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <questions survey-type="4" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import LessonGeneral from "./LessonGeneral.vue";
import Questions from "./../../../components/Questions.vue";

export default {
  components: {
    LessonGeneral,
    Questions
  },
  data() {
    return {
      item: null,

      surveyId: '',
      moduleId: '',
      lessonId: '',

      surveyTitle: '',
      moduleTitle: '',
      lessonTitle: ''
    };
  },
  methods: {
    getLesson: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId + '/lessons/' + this.lessonId;
      
      this.$http.get(url)
          .then(resp => {
            this.item = resp.data.surveyLesson;

            this.surveyTitle = resp.data.surveyTitle;
            this.moduleTitle = resp.data.moduleTitle;
            this.lessonTitle = resp.data.lessonTitle;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },

    parentOnlineTrainingLink() {
      return '/surveys/online-training/' + this.surveyId;
    },
    parentModuleLink() {
      return '/surveys/online-training/' + this.surveyId + '/' + this.moduleId;
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;

    this.getLesson();
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
